import Container from './Container';

const QuestionsFavouriteBarContainer = Container;

export default QuestionsFavouriteBarContainer;
